<template>
  <g>
   <DataNode v-if="node.children.length && node.get_value()>1e-6" :key=node.id :node=node :groupid=group_id :columnid=column_id v-for="node in group" />
  </g>
</template>

<script>

import { mapGetters, mapState } from 'vuex'

import * as d3 from 'd3'
import DataNode from '@/components/DataNode'

export default {
  name: 'DataGroup',
  props: ['group','group_id','column_id'],
  components: {DataNode},
  created(){

  },
  data () {
    return {}
  },
  computed: {
    sorted_sector(){
    },
    mystyle(){
      return {
        "z-index":"5"
        }
      },
  },
  methods: {}
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DataGroup.vue